import { Icon } from '../../components/icons/Icon'
import type { BulkActionDef } from './types'

export interface BulkActionBarProps {
  selectedIds: string[]
  actions: BulkActionDef[]
  onClearSelection: () => void
}

/**
 * Appears on selection. Only real actions render here — anything not
 * implemented in this slice is simply absent (hidden, not disabled), per
 * the IB-4 spec: "other bulk actions hidden, not disabled".
 */
export function BulkActionBar({ selectedIds, actions, onClearSelection }: BulkActionBarProps) {
  if (selectedIds.length === 0) return null
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--iw-space-3)',
        padding: 'var(--iw-space-2) var(--iw-space-4)',
        background: 'var(--iw-accent-subtle)',
        borderTop: '1px solid var(--iw-border)',
      }}
    >
      <span style={{ fontSize: 'var(--iw-size-sm)', fontWeight: 'var(--iw-weight-medium)' as never, color: 'var(--iw-accent)' }}>
        {selectedIds.length} selected
      </span>
      {actions.map((action) => (
        <button
          key={action.id}
          type="button"
          className="iw-btn iw-btn--sm"
          onClick={() => action.onRun(selectedIds)}
        >
          {action.icon ? <Icon name={action.icon} size={13} /> : null}
          {action.label}
        </button>
      ))}
      <span style={{ flex: 1 }} />
      <button type="button" className="iw-btn iw-btn--ghost iw-btn--sm" onClick={onClearSelection}>
        Clear selection
      </button>
    </div>
  )
}
